import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

// Connects to data-controller="visitors-chart"
export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    labels: Array,
    views: Array,
    uniques: Array
  }

  connect() {
    this.initializeChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  initializeChart() {
    const ctx = this.canvasTarget
    const labels = this.hasLabelsValue ? this.labelsValue : []
    const views = this.hasViewsValue ? this.viewsValue : []
    const uniques = this.hasUniquesValue ? this.uniquesValue : []

    // Chart.js throws "Canvas is already in use" if a chart is still bound to
    // this canvas — e.g. after a Turbo cache restore / re-visit, which leaves the
    // chart blank. Tear down any existing instance before creating a new one.
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
    const existing = Chart.getChart(ctx)
    if (existing) {
      existing.destroy()
    }

    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Page Views',
            data: views,
            borderColor: '#3b82f6',
            backgroundColor: 'rgba(59, 130, 246, 0.1)',
            fill: true,
            tension: 0.4,
            borderWidth: 2,
            pointRadius: 0,
            pointHoverRadius: 6,
            pointHoverBackgroundColor: '#3b82f6',
            pointHoverBorderColor: '#fff',
            pointHoverBorderWidth: 2,
          },
          {
            label: 'Unique Visitors',
            data: uniques,
            borderColor: '#10b981',
            backgroundColor: 'rgba(16, 185, 129, 0.08)',
            fill: true,
            tension: 0.4,
            borderWidth: 2,
            pointRadius: 0,
            pointHoverRadius: 6,
            pointHoverBackgroundColor: '#10b981',
            pointHoverBorderColor: '#fff',
            pointHoverBorderWidth: 2,
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'top',
            align: 'end',
            labels: {
              boxWidth: 12,
              boxHeight: 12,
              usePointStyle: true,
              pointStyle: 'circle',
              color: '#6b7280',
              font: { size: 12 }
            }
          },
          tooltip: {
            backgroundColor: '#1f2937',
            titleColor: '#fff',
            bodyColor: '#fff',
            padding: 12,
            cornerRadius: 8,
            displayColors: true,
            mode: 'index',
            intersect: false
          }
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: { color: '#9ca3af', font: { size: 11 }, maxTicksLimit: 12 }
          },
          y: {
            beginAtZero: true,
            grid: { color: '#f3f4f6' },
            ticks: { color: '#9ca3af', font: { size: 11 }, precision: 0 }
          }
        },
        interaction: {
          intersect: false,
          mode: 'index'
        }
      }
    })
  }
}
